import { render } from "./ProjectPreviewBilling.vue?vue&type=template&id=641a8b7c"
import script from "./ProjectPreviewBilling.vue?vue&type=script&lang=js"
export * from "./ProjectPreviewBilling.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__